export default "__VITE_ASSET__DnlaulVz__"